import { render, staticRenderFns } from "./CartPageRecap.vue?vue&type=template&id=53829208"
import script from "./CartPageRecap.vue?vue&type=script&lang=js"
export * from "./CartPageRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports